export const getVolume = volume => {
	return volume.height * volume.width * volume.length;
};